import { render, staticRenderFns } from "./RelatorioDePontoCelular.vue?vue&type=template&id=5b2592b0"
import script from "./RelatorioDePontoCelular.vue?vue&type=script&lang=js"
export * from "./RelatorioDePontoCelular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports